import { Component, OnInit } from '@angular/core';
import { BrowseobligorService } from '../services/browseobligor.service';
import { InvestorBrowseFilings } from '../Models/investor-browse-filings';
import { Observable } from "rxjs";
declare var $: any;

declare function FLFinancialStatementresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
@Component({
  selector: 'app-annual-financial-information',
  templateUrl: './annual-financial-information.component.html',
  styleUrls: ['./annual-financial-information.component.css']
})
export class AnnualFinancialInformationComponent implements OnInit {

  constructor(private browseobligorService: BrowseobligorService) { }

  onKeyUp(event: any) {
    //debugger;
    if (event.keyCode == 38) {
      var parent_cell = $(event.target).index();
      $(event.target).parent().prev().children("td").eq(parent_cell).focus();
      if (event.target.id == "tddocumentDesc" || event.target.id == "tdDocumentLink" || event.target.id == "tdDueDate" || event.target.id == "tdFilingDate") {
        if (event.target.id == "tddocumentDesc") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].title;
        }
        else if (event.target.id == "tdDocumentLink") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].title;
        }
        else if (event.target.id == "tdDueDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].title;
        }
        else if (event.target.id == "tdFilingDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].title;
        }
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
      }
      return;
    }
    else if (event.keyCode == 40) {
      var child_cell = $(event.target).index();
      $(event.target).parent().next().children("td").eq(child_cell).focus();
      if (event.target.id == "tddocumentDesc" || event.target.id == "tdDocumentLink" || event.target.id == "tdDueDate" || event.target.id == "tdFilingDate") {
        if (event.target.id == "tddocumentDesc") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;
        }
        else if (event.target.id == "tdDocumentLink") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].title;
        }
        else if (event.target.id == "tdDueDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].title;
        }
        else if (event.target.id == "tdFilingDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].title;
        }
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
      }
      return;
    }
    else if (event.keyCode == 39) {
      if (event.target.id == "tddocumentDesc") {
        var target = $(event.target).next();
        $(target).trigger('focus');
        if (target[0].id == "tdDocumentLink") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
        }
        return;
      }
      if (event.target.id == "tdDocumentLink") {
        var target = $(event.target).next();
        $(target).trigger('focus');
        if (target[0].id == "tdDueDate") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
        }
        return;
      }
      if (event.target.id == "tdDueDate") {
        var target = $(event.target).next();
        $(target).trigger('focus');
        if (target[0].id == "tdFilingDate") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
        }
        return;
      }
    }
    else if (event.keyCode == 37) {
      if (event.target.id == "tdFilingDate") {
        var target = $(event.target).prev();
        $(target).trigger('focus');
        if (target[0].id == "tdDueDate") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
        }
        return;
      }
      if (event.target.id == "tdDueDate") {
        var target = $(event.target).prev();
        $(target).trigger('focus');
        if (target[0].id == "tdDocumentLink") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
        }
        return;
      }
      if (event.target.id == "tdDocumentLink") {
        var target = $(event.target).prev();
        $(target).trigger('focus');
        if (target[0].id == "tddocumentDesc") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
        }
        return;
      }
    }
    else if (event.keyCode == 13) {
      if (event.target.id == "tdDocumentLink") {
        document.getElementById("DocumentID").click();
        return;
      }
    }
    else if (event.keyCode == 27) {
      if (event.target.id == "tddocumentDesc" || event.target.id == "tdDocumentLink" || event.target.id == "tdDueDate" || event.target.id == "tdFilingDate") {
        document.getElementById("SkipMainContentfooter").focus();
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      }
    }
    else if (event.keyCode == 16)//=============Shift + Tab Go
    {
      if (event.target.id == "tddocumentDesc" || event.target.id == "tdDocumentLink" || event.target.id == "tdDueDate" || event.target.id == "tdFilingDate") {
        document.getElementById("PageObligar").focus();
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("PageObligar").innerText, document.getElementById("PageObligar").id, event.target.type, document.getElementById("PageObligar").title, event.target.htmlFor, event.target.alt, event.key);
        return;
      }
    }
    else {
      if (event.keyCode == 9) {
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
    }
  };
  
  ngOnInit() {
    //debugger;
    document.getElementById("AnnualfinancialID").focus();
    document.getElementById("AnnualfinancialID").tabIndex = 22;

    var OBLIGOR_ID = localStorage.OBLIGOR_ID;
    var OBLIGOR_DESC = localStorage.OBLIGOR_DESC;
    document.getElementById("lblObligar").innerText = OBLIGOR_DESC;
    this.loadSearchObligors(OBLIGOR_ID, "ANNUAL_OP_DATA");
  }

  showModal(documentLink) {
    debugger;
    $("#frame").attr("src", documentLink);
  }

  public InvestorBrowseFilings: InvestorBrowseFilings;

  loadSearchObligors(obligorId: string, filingType: string) {
    //debugger;
    this.browseobligorService.GetInvestorBrowseFilingsWithFilingType(obligorId, filingType).subscribe(data => {
      //debugger;
      if (data['length'] > 0) {
        this.InvestorBrowseFilings = data;
      }
    });
  }
}
